import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":("" + (_vm.$t('Last Name'))),"outlined":"","hide-details":"auto"},model:{value:(_vm.lastname),callback:function ($$v) {_vm.lastname=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"lastname"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }